module.exports = __webpack_public_path__ + "media/images/review/ico-review-heart-fbbc3e68c2b9031a4aaac37ca1d5997e.svg";